import { apiEnvironment } from '../smoothr-web-app-core/environments/apiEnvironment';

export const customerGroup = 'carlsberg_sports_bar';
// export const customerGroup = 'hausmanns';

const supportEmail = {
	[customerGroup]: `${customerGroup}@smoothr.de`,
};
const firebaseConfig = {
	[customerGroup]: {
		apiKey: 'AIzaSyALR1mKh_yQJw_GuWeI5hAJPan4hKsRuMU',
		authDomain: 'carlsberg-sports-bar.firebaseapp.com',
		projectId: 'carlsberg-sports-bar',
		storageBucket: 'carlsberg-sports-bar.firebasestorage.app',
		messagingSenderId: '808137916296',
		appId: '1:808137916296:web:362abc6c97d08aab97043d',
	},
};
export const environment = {
	customerGroup,
	webAppUrl: window.location.protocol + '//' + window.location.host,
	placesApiKey: 'AIzaSyBxctZyYOPXBxP8pv-IsX0F3y16TB3nCFU',
	baseUrl: 'https://api.smoothr.de',
	SUPPORT_EMAIL: supportEmail[customerGroup],
	firebaseConfig: firebaseConfig[customerGroup],
	countryList: ['de'],
	APAY_MERCHANT_ID: 'merchant.smoothr.' + customerGroup,
	allergens_link: '',
	hasRecommendations: true,
	...apiEnvironment,
	hjid: 5035140,
	merchantId: '3000032968',
	merchantGoogleId: 'BCR2DN7TRCR2NIBO',
};
